import { atom } from 'infrastructure/state/jotai.wrapper'
import { atomWithRefresh } from 'infrastructure/state/atomWithRefresh'
import { getAPIRequest } from 'infrastructure/api'
import { fetchDistrict } from 'shared/api/requests'
import { IIngestedDistrict } from 'infrastructure/api'

async function fetchDistrictIngestion(districtId: string | number) {
  const ingestedDistrictData = await getAPIRequest<IIngestedDistrict>(
    `/v1/sis/district/${districtId}/ingested`,
  )
  if (!ingestedDistrictData) return
  return ingestedDistrictData
}

export const districtIdAtom = atom<number | undefined>(undefined)

export const districtResponseAtom = atomWithRefresh((get) => {
  const districtId = get(districtIdAtom)
  if (!districtId) return
  return fetchDistrict(districtId)
})

export const districtIngestionIdAtom = atom<number | string | undefined>(
  undefined,
)

export const districtIngestionResponseAtom = atomWithRefresh((get) => {
  const districtId = get(districtIdAtom)
  if (!districtId) return
  return fetchDistrictIngestion(districtId)
})
